import { Card, CardContent } from '@/components/ui/card';
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/utils';
export default function NoData({
  text = '暂无数据',
  className
}: {
  text?: string;
  className?: string;
}) {
  return (
    <Card className={cn('w-full py-12 text-center', className)}>
      <CardContent className="flex flex-col items-center justify-center space-y-3">
        <Inbox className="text-muted-foreground h-12 w-12" />
        <p className="text-muted-foreground">{text}</p>
      </CardContent>
    </Card>
  );
}
